import { Line, Layer } from '../../../context/context';

export interface LineStyleHandlerProps {
    line: Line;
    global: {
        mapLayers: Layer[];
        activeLayerId: number | null;
    };
    editLayer: (updatedLayer: Layer, layerId: number) => void;
    setSelectedLine: (line: Line | null) => void;
    setIsLineModalOpen: (open: boolean) => void;
}

export function handleLineStyleEdit({
    line,
    global,
    editLayer,
    setSelectedLine,
    setIsLineModalOpen
}: LineStyleHandlerProps) {
    const { activeLayerId, mapLayers } = global;
    const layer = mapLayers.find(l => l.layerId === activeLayerId);
    
    if (layer && activeLayerId !== null) {
        const updatedShapes = layer.shapes.map(shape =>
            shape.id === line.id ? line : shape
        );

        const updatedLayer = {
            ...layer,
            shapes: updatedShapes
        };

        editLayer(updatedLayer, activeLayerId);
        setSelectedLine(null);
        setIsLineModalOpen(false);
    }
} 